// GENERATED by `pnpm modules:sync` from modules/*/package.json — do not edit by hand.
// Browser halves of installed modules, loaded lazily when the organisation has enabled them.
import type { WebModule } from '@tatra/sdk/web';

export const WEB_MODULES: Record<string, () => Promise<{ default: WebModule }>> = {};
